var _g, _defs;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgFastForward(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 20,
    height: 20,
    viewBox: "0 0 20 20",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Layer_1",
    clipPath: "url(#clip0_12519_21436)"
  }, /*#__PURE__*/React.createElement("g", {
    id: "XMLID_837_"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group"
  }, /*#__PURE__*/React.createElement("g", {
    id: "Group_2"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Vector",
    d: "M10 0C4.486 0 0 4.486 0 10C0 15.514 4.486 20 10 20C15.514 20 20 15.514 20 10C20 4.486 15.514 0 10 0ZM10 18.8889C5.09867 18.8889 1.11111 14.9014 1.11111 10C1.11111 5.09861 5.09867 1.11111 10 1.11111C14.9013 1.11111 18.8889 5.09861 18.8889 10C18.8889 14.9014 14.9013 18.8889 10 18.8889Z",
    fill: "white"
  }), /*#__PURE__*/React.createElement("path", {
    id: "Vector_2",
    d: "M8.89788 4.44336V7.25286L4.88354 4.44336V15.5577L8.89782 12.7482V15.5577L16.8382 10.0005L8.89788 4.44336ZM5.99466 13.4239V6.57714L10.8861 10.0005L5.99466 13.4239ZM10.009 11.9706L12.8239 10.0005L10.009 8.03047V6.57714L14.9004 10.0005L10.009 13.4239V11.9706Z",
    fill: "white"
  })))))), _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip0_12519_21436"
  }, /*#__PURE__*/React.createElement("rect", {
    width: 20,
    height: 20,
    fill: "white"
  })))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFastForward);
export default __webpack_public_path__ + "static/media/fast_forward.b232eb8d27512b69ce8db016ab58d6ba.svg";
export { ForwardRef as ReactComponent };